import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Banknote, Truck, MessageCircle } from "lucide-react";
import { BRAND, buildWhatsAppSimpleLink } from "@/lib/brand";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="mt-20 md:mt-28">
      {/* 3 valeurs bandeau bordeaux comme la maquette */}
      <div className="bg-[#5B2333] text-[#F9F6F0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[#F9F6F0]/15">
          {[
            { icon: Banknote, title: "Paiement à la livraison", text: "En espèces — sans frais cachés" },
            { icon: Truck, title: "Livraison rapide", text: "Bruxelles & alentours" },
            { icon: MessageCircle, title: "Commande WhatsApp", text: "Simple, en quelques clics" },
          ].map((item) => (
            <div key={item.title} className="flex items-center gap-4 py-7 px-6">
              <item.icon className="w-7 h-7 text-[#C5A059] shrink-0" strokeWidth={1.2} />
              <div>
                <p className="font-heading text-lg">{item.title}</p>
                <p className="text-xs text-[#F9F6F0]/70 mt-0.5">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Corps du footer */}
      <div className="bg-[#1A1617] text-[#F9F6F0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <p className="font-heading italic text-3xl text-[#C5A059] leading-none">Casa</p>
            <p className="font-heading text-4xl tracking-[0.25em] text-[#F9F6F0] mt-1">VINO</p>
            <p className="text-[10px] tracking-[0.2em] uppercase text-[#C5A059]/80 mt-2">
              Vino artisanale di Puglia
            </p>
            <p className="text-sm text-[#F9F6F0]/70 mt-6 leading-relaxed max-w-md">
              Importateur direct de vins artisanaux des Pouilles. Livraison à
              Bruxelles et alentours. Paiement cash à la livraison.
            </p>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-[#C5A059] mb-5">
              Liens rapides
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" data-testid="footer-link-accueil" className="hover:text-[#C5A059] transition-colors">Accueil</Link></li>
              <li><Link to="/vins" data-testid="footer-link-vins" className="hover:text-[#C5A059] transition-colors">Nos vins</Link></li>
              <li><Link to="/reservation" data-testid="footer-link-reservation" className="hover:text-[#C5A059] transition-colors">Dégustation</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-[#C5A059] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-[#C5A059] mb-5">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-[#F9F6F0]/80">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#C5A059]" strokeWidth={1.5} />
                <span>{BRAND.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#C5A059]" strokeWidth={1.5} />
                <a
                  href={buildWhatsAppSimpleLink()}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-phone-link"
                  className="hover:text-[#C5A059]"
                >
                  {BRAND.phoneDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F9F6F0]/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#F9F6F0]/50">
            <span>© {new Date().getFullYear()} Casa Vino — Tous droits réservés</span>
            <span className="italic text-center sm:text-right">Bevi responsabilmente · L&apos;abus d&apos;alcool est dangereux pour la santé.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
